import { gtm } from 'apps/gtm';
import { wa, pageEventTypes } from 'apps/analytics';

export const triggerGtmAddToBasket = (itemsChanges) => {
  itemsChanges.forEach(change => {
    if (change.analyticsData && change.analyticsData.quantityChange > 0) {
      gtm.trigger('gtm:basketAddEvent', change.sku);
    }
  });
};

export const triggerGtmChangeBasket = ({ data, actionParams }) => {
  const { analyticsData } = data;
  const { basket } = actionParams;
  const value = basket.value + analyticsData.totalPriceChange;
  gtm.trigger('gtm:basketChangedEvent', {
    basketValue: value,
    emptyBasket: value === 0,
  });
};

export const triggerGtmClearBasket = () => {
  gtm.trigger('gtm:basketChangedEvent', {
    basketValue: 0,
    emptyBasket: true,
  });
};

function getCouponsInfo(basket) {
  const couponsInfo = {};
  if (!basket || !basket.items) {
    return couponsInfo;
  }
  basket.items.forEach(item => {
    if (item.quantity > 0 && item.coupon) {
      couponsInfo[item.coupon.id] = item.sku;
    }
  });
  return couponsInfo;
}

export const triggerCouponsAnalytics = ({ requestParams: { actionParams: { basket, getState } } }) => () => {
  if (!basket || !getState) {
    return;
  }

  const prevCoupons = getCouponsInfo(basket);
  const newCoupons = getCouponsInfo(getState().basket);

  Object.keys(prevCoupons).forEach(couponId => {
    if (!newCoupons[couponId]) {
      wa.triggerPageEvent(pageEventTypes.COUPON_CANCELLED, {
        PER_COUPON_ID: couponId,
      });
    }

    if (newCoupons[couponId] && newCoupons[couponId] !== prevCoupons[couponId]) {
      wa.triggerPageEvent(pageEventTypes.COUPON_CANCELLED, {
        PER_COUPON_ID: couponId,
      });
      wa.triggerPageEvent(pageEventTypes.COUPON_APPLIED, {
        PER_COUPON_ID: couponId,
      });
    }
  });

  Object.keys(newCoupons).forEach(couponId => {
    if (!prevCoupons[couponId]) {
      wa.triggerPageEvent(pageEventTypes.COUPON_APPLIED, {
        PER_COUPON_ID: couponId,
      });
    }
  });
};
